import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService, TranslatePipe, TranslateDirective } from "@ngx-translate/core";
import { setLogLevel, LogLevel } from "@angular/fire";

import { Header} from './core/header/header';
import { Footer} from './core/footer/footer';
import { Sidenav} from './core/sidenav/sidenav';

import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    CommonModule,
    Header,
    Footer,
    Sidenav,
    MatSidenavModule
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  //================================================================================================
  //  変数定義
  //================================================================================================
  isProvider                    = true;                                                             //
  //================================================================================================
  //  コンストラクタ
  //================================================================================================
  constructor(private router: Router,
              private translate: TranslateService) {
    translate.setDefaultLang('ja');
    translate.addLangs(['ja','en']);
    let opca_language = localStorage.getItem('le_base_language');
    if (opca_language=='ja' || opca_language=='en') {
      translate.use(opca_language);
    } else {
      translate.use('ja');
    }
    // //  呼び出しURLのチェック
    // router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     const array = ['/login', '/signup', '/twofactor', '/mail-action', '/sys-admin', '/group', '/access-log', '/le-admin', '/le-user', '/opr', '/api-account', '/keys-versions', '/wsp', '/ca']
    //     this.isProvider = false;
    //     if (event.url.startsWith("/authorize")) {
    //       this.isProvider = true;
    //     }
    //     if (!array.includes(event.url)) {
    //       this.isProvider = true;
    //     }
    //   }
    // });


    // 「Firebase API called outside injection context:〜」のワーニングを非表示にする
    setLogLevel(LogLevel.SILENT);    
  }
  protected title = 'le-base-mng';
}
